module.exports = __webpack_public_path__ + "img/image-thumb-8.58f7eef5.webp";